import { FONT_SVG_PREVIEW_ASSETS } from "./fontSvgPreviewAssets";

export function fontFamilyPreviewSvg(family: string): string | undefined {
  return FONT_SVG_PREVIEW_ASSETS[fontFamilySvgSlug(family)];
}

export function fontFamilySvgSlug(family: string): string {
  return family
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
